export const botEnvironments = {
  dev: {
    "b2c-support-r2": {
      env: "dev" as const,
      sendMessageEndpoint:
        "https://b2c.dev.bot-autoatencion.git.copec.cl/v1/post-utterance/b2c/v2",
      apiKey: "ADLZrRTth82H79mEeQhOk4y2NcWHtQWo9ZFkKtRE",
      apiKeyWs: "da2-gvylt5vbw5bbrgvp4xpeitxjcy",
      wsRealTimeEndpoint:
        "wss://kunwqb4gf5duvmmb4c7rqcp24u.appsync-realtime-api.us-west-2.amazonaws.com/graphql",
      wsEndpoint:
        "kunwqb4gf5duvmmb4c7rqcp24u.appsync-api.us-west-2.amazonaws.com",
      subscriptionAtributes: `{
              messageId
              sessionId
              text
              answeredMessageId
              agentName
              transferIntent
              requestKey
              agentTrace
              mergedMessages { messageId text }
              }`,
    },
    "b2c-support-r1": {
      env: "dev" as const,
      sendMessageEndpoint:
        "https://b2c.dev.bot-autoatencion.git.copec.cl/r1/post-utterance/b2c/v2", 
      apiKey: "0m2zqAGefJ6lfgyxHGuzK2jWeOG6yKpr1JFNxYcn", 
      apiKeyWs: "da2-jvgzbf7bezadrhky27oidcqlpe", 
      wsRealTimeEndpoint:
        "wss://vgpfzffluzac5hdv2x43xsstmi.appsync-realtime-api.us-west-2.amazonaws.com/graphql", 
      wsEndpoint:
        "vgpfzffluzac5hdv2x43xsstmi.appsync-api.us-west-2.amazonaws.com", 
      subscriptionAtributes: `{
              messageId
              sessionId
              text
              answeredMessageId
              agentName
              transferIntent
              requestKey
              agentTrace
              mergedMessages { messageId text }
              }`,
    },
  },
  stg: {
    "b2c-support-r2": {
      env: "stg" as const,
      sendMessageEndpoint:
        "https://b2c.stg.bot-autoatencion.git.copec.cl/v1/post-utterance/b2c/v2",
      apiKey: "RHQTsEMrx46qQvaoco4Z8UJbD1oqCJKat9QiqUC0",
      apiKeyWs: "da2-zqiww2ykbnbx7oxdll5slxdqba",
      wsRealTimeEndpoint:
        "wss://ko3l6grnvbddliloytrbox4phe.appsync-realtime-api.us-west-2.amazonaws.com/graphql",
      wsEndpoint:
        "ko3l6grnvbddliloytrbox4phe.appsync-api.us-west-2.amazonaws.com",
      subscriptionAtributes: `{
              messageId
              sessionId
              text
              answeredMessageId
              agentName
              transferIntent
              requestKey
              agentTrace
              mergedMessages { messageId text }
              }`,
    },
    "b2c-support-r1": {
      env: "stg" as const,
      sendMessageEndpoint:
        "https://b2c.stg.bot-autoatencion.git.copec.cl/r1/post-utterance/b2c/v2", 
      apiKey: "ns6vpv0hx233Nzs4pCj875EOjiRTAIRO2wDBMtpc", 
      apiKeyWs: "da2-6lbn4w2yyzfilkav46eiyrjrd4", 
      wsRealTimeEndpoint:
        "wss://fbv6ydkwgvfyxfi7f7wbk6w4gm.appsync-realtime-api.us-west-2.amazonaws.com/graphql", 
      wsEndpoint:
        "fbv6ydkwgvfyxfi7f7wbk6w4gm.appsync-api.us-west-2.amazonaws.com", 
      subscriptionAtributes: `{
              messageId
              sessionId
              text
              answeredMessageId
              agentName
              transferIntent
              requestKey
              agentTrace
              mergedMessages { messageId text }
              }`,
    },
  },
  prd: {
    "b2c-support-r2": {
      env: "prd" as const,
      sendMessageEndpoint:
        "https://b2c.prd.bot-autoatencion.git.copec.cl/v1/post-utterance/b2c/v2",
      apiKey: "tmhQ3PkmCf2U0ISHZquDl8yfBLEwdIC1s0xIqpG1",
      apiKeyWs: "da2-oz7ktpgdh5ahzcgwif5s7e2xdi",
      wsRealTimeEndpoint: "wss://ss2wkyav5nfezc2kxrlzlqiqzq.appsync-realtime-api.us-west-2.amazonaws.com/graphql",
      wsEndpoint: "ss2wkyav5nfezc2kxrlzlqiqzq.appsync-api.us-west-2.amazonaws.com",
      subscriptionAtributes: `{
              messageId
              sessionId
              text
              answeredMessageId
              agentName
              transferIntent
              requestKey
              agentTrace
              mergedMessages { messageId text }
              }`,
    },
    "b2c-support-r1": {
      env: "prd" as const,
      sendMessageEndpoint:
        "https://b2c.prd.bot-autoatencion.git.copec.cl/r1/post-utterance/b2c/v2", 
      apiKey: "izXLkKldLs75DGvVhFEaA19HxQa3DdUT5fTsDEZf", 
      apiKeyWs: "da2-mhrc5i7w4jf7rp7kucuoql6abm", 
      wsRealTimeEndpoint:
        "wss://iyeewmx5vve2ldk6nzqiuo5aju.appsync-realtime-api.us-west-2.amazonaws.com/graphql", 
      wsEndpoint:
        "iyeewmx5vve2ldk6nzqiuo5aju.appsync-api.us-west-2.amazonaws.com", 
      subscriptionAtributes: `{
              messageId
              sessionId
              text
              answeredMessageId
              agentName
              transferIntent
              requestKey
              agentTrace
              mergedMessages { messageId text }
              }`,
    },
  },
};